module.exports = __webpack_public_path__ + "img/message-sp-1.8bdcf70b.jpg";